<script setup>
const props = defineProps({
  customClass: String,
  size: String,
});

const sizeClass = ref(
  props.size ? "w-" + props.size + " h-" + props.size : "w-24px h-24px"
);
</script>

<template>
  <svg
    class="icon icon--close"
    :class="[sizeClass, customClass]"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    aria-hidden="true"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M6 18 18 6M6 6l12 12"
    />
  </svg>
</template>
